module.exports = __webpack_public_path__ + "static/media/Product-tabicon3.53a2935a.png";